import React from 'react';
import logo from './images/Logo..png';

const PrivacyPolicy = () => {
    return (
        <div className="min-h-screen bg-[#F7F8FA] py-12 px-4 sm:px-6 lg:px-8">
            <div className="max-w-3xl mx-auto">
                <div className="flex justify-center mb-10">
                    <img src={logo} alt="Fisico da Urlo" className="h-24 w-auto object-contain" />
                </div>
                
                <div className="bg-white shadow-[0_8px_30px_rgb(0,0,0,0.04)] rounded-2xl p-8 md:p-12 overflow-hidden">
                    <h1 className="text-3xl font-extrabold text-[#001621] mb-8 text-center border-b pb-6 border-slate-100">
                        Informativa sulla Privacy – Fisico da Urlo
                    </h1>
                    
                    <div className="space-y-8 text-slate-600 leading-relaxed text-lg">
                        <section>
                            <p>
                                Fisico da Urlo è l’applicazione ufficiale della palestra Fisico da Urlo. La tua privacy è importante per noi e questa informativa descrive come raccogliamo, utilizziamo e proteggiamo i tuoi dati.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-xl font-bold text-[#001621] mb-4">Dati Raccolti</h2>
                            <p className="mb-4">L’app può raccogliere le seguenti informazioni:</p>
                            <ul className="list-disc pl-6 space-y-2 mb-4">
                                <li>Dati di identificazione di base forniti dalla palestra (come ID membro)</li>
                                <li>Dati di presenza generati tramite la scansione del QR code</li>
                                <li>Dati di utilizzo dell’app necessari al corretto funzionamento</li>
                            </ul>
                            <p>
                                L’app non raccoglie dati personali sensibili come informazioni di pagamento, contatti, foto o posizione precisa.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-xl font-bold text-[#001621] mb-4">Utilizzo dei Dati</h2>
                            <p className="mb-4">I dati raccolti vengono utilizzati esclusivamente per:</p>
                            <ul className="list-disc pl-6 space-y-2">
                                <li>Registrare e gestire le presenze in palestra</li>
                                <li>Verificare l’accesso dei membri</li>
                                <li>Migliorare il funzionamento e l’affidabilità dell’app</li>
                            </ul>
                        </section>

                        <section>
                            <h2 className="text-xl font-bold text-[#001621] mb-4">Condivisione dei Dati</h2>
                            <p>
                                Non vendiamo, scambiamo o condividiamo i dati degli utenti con terze parti. I dati sono accessibili solo al personale autorizzato della palestra per la gestione delle presenze.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-xl font-bold text-[#001621] mb-4">Sicurezza dei Dati</h2>
                            <p>
                                Adottiamo misure di sicurezza adeguate per proteggere i dati da accessi non autorizzati, perdita o uso improprio. I dati di presenza vengono conservati in modo sicuro e utilizzati esclusivamente per scopi interni alla palestra.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-xl font-bold text-[#001621] mb-4">Modifiche all’Informativa</h2>
                            <p>
                                La presente Informativa sulla Privacy può essere aggiornata periodicamente. Eventuali modifiche saranno comunicate tramite l’app o la pagina ufficiale dell’informativa.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-xl font-bold text-[#001621] mb-4">Contatti</h2>
                            <p>
                                Per qualsiasi domanda relativa a questa Informativa sulla Privacy, è possibile contattare direttamente la palestra.
                            </p>
                        </section>
                    </div>
                </div>
                
                <div className="text-center mt-8 text-slate-400 text-sm">
                    &copy; {new Date().getFullYear()} Fisico da Urlo. Tutti i diritti riservati.
                </div>
            </div>
        </div>
    );
};

export default PrivacyPolicy;
